import React from 'react'
import { ConversionCampaignOffer, OfferMeta } from '../../../../types/conversions'
import LockedOffer from '../LockedOffer/LockedOffer'
import OfferMilestones from '../OfferMilestones/OfferMilestones'
import { formatDateRelative } from '../../../../utils/helpers'
import PointInfluns from '../../../../assets/icons/PointInfluns'
import PointExtra from '../../../../assets/icons/PointExtra'
import PointLink from '../../../../assets/icons/PointLink'
import PointCommunity from '../../../../assets/icons/PointCommunity'
import PointReward from '../../../../assets/icons/PointReward'
import { Currency } from '../../../../types'

const PlatformSale: React.FC<{ offer: ConversionCampaignOffer, meta: OfferMeta, currency: Currency }> = ({ offer, meta, currency }) => {
    
    return (
        <div>
            {
            offer.milestone_visible ? (
                <div>
                    <OfferMilestones offer={offer} meta={meta} currency={currency} />
                    <div className="d-flex align-items-center flex-column my-3 gap-4 w-100">
                        <div className='offer-ends-in'>Ends {formatDateRelative(offer.effective_till)}</div>
                        <div className="offer-why-matters app-card  w-100">
                        <div className="offer-why-matters__title">Why this matters</div>
                        <div className="offer-why-matters__list">
                            <div className="offer-why-matters__item">
                                <span className="offer-why-matters__icon">
                                    <PointInfluns />
                                </span>
                                <span className="offer-why-matters__text">Not Just Another Campaign. An Influns Exclusive.</span>
                            </div>

                            <div className="offer-why-matters__item">
                                <span className="offer-why-matters__icon">
                                    <PointLink />
                                </span>
                                <span className="offer-why-matters__text">Invite creators. Grow faster together</span>
                            </div>

                            <div className="offer-why-matters__item">
                                <span className="offer-why-matters__icon">
                                    <PointCommunity />
                                </span>
                                <span className="offer-why-matters__text">Community wins &gt; individual competition</span>
                            </div>

                            <div className="offer-why-matters__item">
                                <span className="offer-why-matters__icon">
                                    <PointReward />
                                </span>
                                <span className="offer-why-matters__text">You build the platform, you share the rewards</span>
                            </div>
                        </div>
                    </div>
                    </div>
                   
                </div>
            ) : (
                <LockedOffer offer={offer} meta={meta} currency={currency} />
            )
        }
        </div>
    )
}

export default PlatformSale